<template>
  <vuex-table :fields="fields" :auto_start="false" table_store="core/prices/table" />
</template>

<script>
  import { toUserDateWithTime } from '@shared/helpers/date_format';

  export default {
    computed: {
      fields: function() {
        return [
          {
            key: 'name',
            label: this.$t('shared.component.table.field.title'),
            sortable: true,
            class: 'w-50'
          },
          {
            key: 'end',
            label: this.$t('core.price.field.date_end'),
            sortable: true,
            class: 'w-25',
            formatter: value => toUserDateWithTime(value)
          },
          {
            key: 'price',
            label: this.$t('core.price.field.price'),
            sortable: true,
            class: 'w-25',
            formatter: value => this.$numeral.currency(value)
          }
        ];
      }
    }
  };
</script>
